import { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useParams } from 'react-router-dom';
import Link from './Link';

import Grid from '@mui/joy/Grid';
import Stack from '@mui/joy/Stack';
import Button from '@mui/joy/Button';
// import Typography from '@mui/joy/Typography';
// import ListItemButton from '@mui/joy/ListItemButton';
// import ListItemDecorator from '@mui/joy/ListItemDecorator';

import SettingsTwoToneIcon from '@mui/icons-material/SettingsTwoTone';
import ListicleProject from './ListicleProject';

import useProject from 'hooks/useProject';
import useUserIdentity from 'hooks/useUserIdentity';
import { ProjectProps } from 'stores/project_store';
import  ProjectCopy  from './ProjectCopy';
import LoadingSection from 'components/LoadingSection';

export const ProjectOverview = observer(() => {
    const { projectKey = "" } = useParams<{ projectKey: string }>();
    const { currentIdentity } = useUserIdentity();
    const {
        getProject,
        fetchProject,
        // getIdentityProjects,
    } = useProject();
    const [project, setProject] = useState<ProjectProps | undefined>(getProject(projectKey));

    useEffect(() => {
        if(!currentIdentity?.uuid) return;

        // Load the project if it is not already loaded
        if (projectKey && (project?.uuid !== projectKey)) {
            fetchProject(currentIdentity.uuid, projectKey)
                .then(() => {
                    setProject(getProject(projectKey));
                })
        }

    }, [currentIdentity?.uuid, projectKey, project?.uuid]);
    return (
        <Grid container >

            <Grid xs={12} sm={7}>
                { project === undefined &&
                    <LoadingSection /> }
                { project !== undefined &&
                    <Stack >
                        <ListicleProject
                            hideTitle={true}
                            project={project} />
                    </Stack>
                }
            </Grid>

            <Grid xs={12} sm={5}>
                <Stack padding={1}>
                    <Stack ml={2}>
                        <Link to={`/project/${projectKey}/settings`}>
                            <Button
                                color="neutral"
                                fullWidth
                                startDecorator={<SettingsTwoToneIcon />}
                                variant="plain">
                                Project Settings
                            </Button>
                        </Link>
                    </Stack>

                    <ProjectCopy />

                </Stack>
            </Grid>
        </Grid>
    );

});

export default ProjectOverview;
